var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgRightPersonLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 326,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.513 20.759c-6.796 12.715-5.989 44.968 2.795 47.24 3.503.907 10.964-1.313 18.559-5.908l-4.767 33.85h28.148l-9.689-45.334c5.403-6.367 9.061-14.17 8.449-22.913-1.761-25.192-36.699-19.65-43.495-6.935z",
    fill: "#B28B67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.856 26.468c.278-1.648.96-3.478 1.51-5.038.708-2.01 1.781-3.822 2.962-5.53 2.222-3.216 4.888-6.12 7.832-8.53 5.377-4.403 12.222-6.942 18.953-6.118a19.416 19.416 0 019.505 3.884c2.537 1.956 4.977 4.837 8.263 5.044 3.574.225 6.85-2.942 9.717-4.898 3.232-2.204 6.671-3.811 10.448-4.436 6.329-1.045 12.274 1.1 16.635 6.312 4.641 5.546 8.015 13.68 4.967 21.027-.566 1.366-1.295 2.518-2.341 3.472-.96.875-2.425 1.807-2.814 3.205-.413 1.487.821 3.404 1.3 4.746.685 1.921 1.248 3.938 1.048 6.027-.329 3.43-2.476 6.705-4.744 8.96-2.308 2.294-5.148 3.61-8.182 4.216-2.025.405-4.096.628-6.154.476-1.022-.075-1.924-.36-2.914-.587-.963-.22-1.501.037-2.318.567-3.796 2.462-7.876 3.415-12.259 3.05-3.698-.31-7.961-1.21-10.978-3.753-3.351-2.825-3.284-6.72-2.496-10.883-.835.416-3.146.673-1.765-.983.547-.657 1.58-.923 2.282-1.31.818-.449 1.648-1.03 2.282-1.762 2.563-2.959-.025-8.98-3.246-9.973-4.786-1.474-5.857 5.319-9.274 7.076-1.964 1.01-4.019-.37-5.49-1.78-1.972-1.89-3.315-4.392-4.475-6.938-.956-2.098-1.845-4.224-2.819-6.311-.454-.975-2.029-3.73-1.238-4.831-3.428-.686-7.246.743-10.198 2.618-1.22.776-2.15 1.63-2.801 2.998-.139.294-.443 1.165-.824 1.2-.71.068-.444-.803-.374-1.217z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.629 193.649l-42.52 149.772L89.086 453.81H66.46l32.967-260.161h63.203z",
    fill: "#1E2D3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.001 193.649c.984 77.194 4.338 119.298 5.37 126.311 1.033 7.014 16.647 51.631 46.841 133.85h-23.44c-38.44-78.876-59.898-123.492-64.375-133.85-4.476-10.357-18.291-52.461-39.098-126.311H174z",
    fill: "#2E4357"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.835 179.546l-24.508.097c15.133 49.035 23.302 75.052 24.508 78.053 2.714 6.75-3.029 17.032-5.485 22.557 7.999 3.592 7.147-9.712 17.237-5.001.921.43 1.82.895 2.702 1.377l.878.487c.582.328 1.157.661 1.728.993l.853.497c6.516 3.801 12.537 7.202 20.695 2.15 1.308-.811 2.741-3.861-.722-6.245-8.629-5.939-21.065-16.334-22.745-19.755-2.291-4.666-7.338-29.736-15.141-75.21zm-147.464-4.588L26.148 207.49c-9.667 4.139-17.588 8.709-23.762 13.711-1.388 1.681-2.9 4.902 3.633 3.461 6.533-1.442 13.469-2.663 14.697-.531 1.227 2.133-2.39 5.401-.121 8.191 1.513 1.861 6.6-4.057 15.263-17.754l34.547-20.445-11.034-19.165z",
    fill: "#B28B67"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.185 76.32l-10.141-1.745c-17.46 43.78-47.944 83.56-91.451 119.34l32.876 40.091c43.502-50.945 70.317-103.507 68.716-157.685z",
    fill: "#2F6779"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.395 204.244H91.089c20.922-51.06 31.382-94.436 31.382-130.126l27.241-4.074c21.409 34.56 27.455 77.112 31.683 134.2z",
    fill: "#DDE3E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.5 70.044c-2.128.073-5.369.206-9.723.397l-6.582 18.882c-.696 23.02-4.762 69.413-12.198 139.179l59.197-.001a363.1 363.1 0 01-.767 14.591h44.016c-6.584-74.559-30.628-132.242-72.133-173.048l-.02.02-.012-.02H148.5z",
    fill: "#2F6779"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.629 228.966l16.55-.002c.724-21.608-.574-42.311-3.894-62.11-1.687 30.034-5.905 50.737-12.656 62.112z",
    fill: "#000",
    fillOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.018 192.473l-29.19-13.621v13.621h29.19z",
    fill: "#fff",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.208 40.303l35.26 11.47-7.979 24.642-16.24-5.283c-10.504-3.417-16.261-14.706-12.858-25.215l1.817-5.614z",
    fill: "#C4C4C4"
  })));
}
export default SvgImgRightPersonLarge;